const clickBtn = document.getElementById("clickBtn");
const popup = document.getElementById("popup");
const closeBtn = document.getElementById("closeBtn");

if (popup) {
  clickBtn.addEventListener('click', () => {
  popup.style.display = 'block';
  document.body.style.overflow = 'hidden'; // Prevent body scrolling
});

closeBtn.addEventListener('click', () => {
  popup.style.display = 'none';
  document.body.style.overflow = 'auto'; // Enable body scrolling
});
}

